define('drops/multiSelect/checkboxList',[
    'jquery',
    'underscore'
], function($, _) {
    'use strict';

    var CheckboxList = function (drop) {
        this.drop = drop;

        this.$el = $('<div />')
            .addClass('multi-checkbox')
            .appendTo(drop.$element);
    };

    CheckboxList.prototype.render = $.noop;

    CheckboxList.prototype.setItems = function (items) {
        this.createAllOption();
        this.createCells(items);
        this.fillList();
        this.updateSelection();
        this.setTabIndex();
    };

    CheckboxList.prototype.createCells = function (items) {
        var self = this;
        this.cells = _.chain(items)
            .map(function (item) {
                return {
                    id: item[self.drop.data.idOutput],
                    label: item[self.drop.data.displayedOutput]
                };
            })
            .map(function (item) {
                return self.createCell(item);
            })
            .value();
    };

    CheckboxList.prototype.createCell = function(item) {
        var $checkbox = $('<input type="checkbox" id="' + _.uniqueId('multiselect_') + '" />')
            .prop('checked', this.drop.data.selectAllByDefault);
        var rowModel = {
            id: item.id,
            checked: !!this.drop.data.selectAllByDefault,
            $el: $('<div />'),
            check: function () {
                rowModel.checked = true;
                $checkbox.prop('checked', true);
            },
            uncheck: function () {
                rowModel.checked = false;
                $checkbox.prop('checked', false);
            }
        };

        if (this.drop.data.readOnly)
            $checkbox.prop('disabled', true);

        var self = this;
        $checkbox
            .on('change', function() {
                rowModel.checked = $checkbox.prop('checked');

                self.drop.updateRequiredIndicator();
                self.drop.triggerEventIfEnabled('changed');

                if (rowModel.checked)
                    self.drop.triggerEventIfEnabled('itemSelected', rowModel.id);
                else
                    self.drop.triggerEventIfEnabled('itemDeselected', rowModel.id);

                self.updateAllOption();
            });

       this.buildItemTable($checkbox, item.label)
            .appendTo(rowModel.$el);

        return rowModel;
    };

    CheckboxList.prototype.buildItemTable = function ($checkbox, label) {
        var $ticker = this.drop.data.useBuiltInStyle
            ? $checkbox
            : $('<label class="customCheckState" />')
                .append($checkbox)
                .append($('<div class="drop-text-content customCheckState-tick"></div>')
                .append($('<div>&#x2714</div>')));

        return $('<div />')
            .css({
                display: 'table',
                whiteSpace: 'pre-wrap'
            })
            .append($('<div />')
                .css({
                    display: 'table-row'
                })
                .append($('<div />')
                    .css({
                        display: 'table-cell'
                    })
                    .append($ticker))
                .append($('<div />')
                    .css({
                        display: 'table-cell'
                    })
                    .addClass('drop-text-content')
                    .append($('<label for="' + $checkbox.attr('id') + '" />')
                        .text(label))));
    };

    CheckboxList.prototype.updateAllOption = function() {
        if (!this.$all)
            return;

        var $allCheckbox = this.$all.find('input');

        if (!_.findWhere(this.cells, { checked: false }))
            $allCheckbox.prop('checked', true);
        else
            $allCheckbox.prop('checked', false);
    };

    CheckboxList.prototype.fillList = function () {
        var drop = this.drop;

        var cells = _.pluck(this.cells, '$el');
        if (this.$all)
            cells = [this.$all].concat(cells);

        var $rows = _.chain(cells)
            .groupBy(function (cell, index) {
                return Math.floor(index/drop.data.numberOfColumns);
            })
            .map(function(row) {
                return $('<div />').css({
                    width: '100%',
                    display: 'table',
                    tableLayout: 'fixed'}).append(row);
            })
            .value();
        this.$el.empty();

        var leftover = cells.length % this.drop.data.numberOfColumns;
        var numOfBlankElements = this.drop.data.numberOfColumns - leftover;
        for (var i = 0; i < numOfBlankElements && leftover > 0; i++) {
            $rows[$rows.length - 1].append($('<div />'));
        }

        this.$el
            .append($('<div />').addClass('multi-checkbox-options').append($rows));
    };

    CheckboxList.prototype.clear = function() {
        _.each(this.cells, function (cell) {
            cell.uncheck();
        });

        this.drop.updateRequiredIndicator();
        this.updateAllOption();
    };

    CheckboxList.prototype.setTabIndex = function() {
        this.$el.find('input')
            .first()
            .attr('tabindex', this.drop.data.tabIndex);
    };

    CheckboxList.prototype.setValue = function (selection) {
        this.selection = selection;
        this.updateSelection();
    };

    CheckboxList.prototype.createAllOption = function () {
        if (this.drop.data.addAllOption) {
            var self = this;

            var $checkbox = $('<input type="checkbox" id="' + _.uniqueId('multiselect_') + '" />')
                .prop('checked', this.drop.data.selectAllByDefault)
                .on('change', function() {
                    var $this = $(this);

                    var checked = $this.prop('checked');

                    _.each(self.cells, function(cell) {
                        if (checked && !cell.checked) {
                            cell.check();
                            self.drop.triggerEventIfEnabled('itemSelected', cell.id);
                        } else if (!checked && cell.checked) {
                            cell.uncheck();
                            self.drop.triggerEventIfEnabled('itemDeselected', cell.id);
                        }
                    });

                    self.drop.updateRequiredIndicator();
                    self.drop.triggerEventIfEnabled('changed');
                });

            if (this.drop.data.readOnly)
                $checkbox.prop('disabled', true);

            this.$all = this.buildItemTable($checkbox, this.drop.data.allOptionLabel);
        }
    };

    CheckboxList.prototype.updateSelection = function () {
        if (!this.selection)
            return;

        var self = this;
        _.each(this.cells, function (cell) {
            var selected = self.selection.indexOf(cell.id) !== -1;
            if (selected)
                cell.check();
            else
                cell.uncheck();
        });

        this.drop.updateRequiredIndicator();
        this.updateAllOption();
    };

    CheckboxList.prototype.getValue = function () {
        return _.chain(this.cells)
            .where({ checked: true })
            .map(function (cell) {
                return cell.id;
            })
            .value();
    };

    CheckboxList.prototype.dispose = $.noop;

    return CheckboxList;
});
